import { call } from 'redux-saga/effects';
import { APIHandler } from '../commonHandlers';

function* getQuarantines(api, action) {
  yield call(APIHandler, api, action);
}

function* getUserHealthQuarantineById(api, action) {
  yield call(APIHandler, api, action);
}

function* getUserLocationQuarantineById(api, action) {
  yield call(APIHandler, api, action);
}
function* getUserContactQuarantineById(api, action) {
  yield call(APIHandler, api, action);
}
export default {
  getQuarantines,
  getUserHealthQuarantineById,
  getUserLocationQuarantineById,
  getUserContactQuarantineById
};
